import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gradient-to-br from-[#4D5D33] via-[#556640] to-[#4D5D33] text-white py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Company Branding Section */}
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-white rounded-lg p-2">
                <img
                  src="https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/Gemini_Generated_Image_zga35ozga35ozga3.png"
                  alt="Masala Chai Tea Logo"
                  className="h-12 md:h-16 w-auto"
                  crossOrigin="anonymous"
                />
              </div>
              <span className="text-xl md:text-2xl text-[#E2725B]" style={{ fontFamily: 'Great Vibes, cursive', textShadow: '1px 1px 2px rgba(0,0,0,0.3)' }}>
                Masala Chai Tea
              </span>
            </div>
            <div className="elegant-divider mb-4 opacity-30" style={{ maxWidth: '200px' }}></div>
            <p className="text-gray-300 text-sm md:text-base text-center md:text-left max-w-xs leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links Section */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-lg md:text-xl font-bold mb-2 text-white font-elegant">{t('footer.quickLinks')}</h3>
            <div className="elegant-divider mb-4 opacity-30" style={{ maxWidth: '120px' }}></div>
            <nav className="flex flex-col space-y-3">
              <Link
                to="/"
                className="text-gray-300 hover:text-white transition-colors text-sm md:text-base text-center md:text-left"
              >
                {t('nav.home')}
              </Link>
              <Link
                to="/products"
                className="text-gray-300 hover:text-white transition-colors text-sm md:text-base text-center md:text-left"
              >
                {t('nav.products')}
              </Link>
              <Link
                to="/about"
                className="text-gray-300 hover:text-white transition-colors text-sm md:text-base text-center md:text-left"
              >
                {t('nav.about')}
              </Link>
              <Link
                to="/faq"
                className="text-gray-300 hover:text-white transition-colors text-sm md:text-base text-center md:text-left"
              >
                {t('nav.faq')}
              </Link>
              <Link
                to="/contact"
                className="text-gray-300 hover:text-white transition-colors text-sm md:text-base text-center md:text-left"
              >
                {t('nav.contact')}
              </Link>
            </nav>
          </div>

          {/* Contact Information Section */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-lg md:text-xl font-bold mb-2 text-white font-elegant">{t('footer.contactUs')}</h3>
            <div className="elegant-divider mb-4 opacity-30" style={{ maxWidth: '120px' }}></div>
            <div className="flex flex-col space-y-4">
              {/* Email */}
              <div className="flex items-center gap-3 justify-center md:justify-start">
                <svg className="w-5 h-5 flex-shrink-0 text-[#FFDB58]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a
                  href="mailto:chaiteamasalaus@gmail.com"
                  className="text-gray-300 hover:text-white transition-colors text-sm md:text-base break-all"
                >
                  chaiteamasalaus@gmail.com
                </a>
              </div>

              {/* Location */}
              <div className="flex items-center gap-3 justify-center md:justify-start">
                <svg className="w-5 h-5 flex-shrink-0 text-[#FFDB58]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="text-gray-300 text-sm md:text-base text-center md:text-left">
                  New Braunfels, TX
                </span>
              </div>
            </div>
          </div>

          {/* Business Hours Section */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-lg md:text-xl font-bold mb-2 text-white font-elegant">{t('footer.businessHours')}</h3>
            <div className="elegant-divider mb-4 opacity-30" style={{ maxWidth: '140px' }}></div>
            <div className="flex flex-col space-y-3 text-center md:text-left">
              <div className="flex items-center gap-3 justify-center md:justify-start">
                <svg className="w-5 h-5 flex-shrink-0 text-[#FFDB58]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div className="text-sm md:text-base">
                  <p className="text-gray-300 font-semibold">{t('footer.availability')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              &copy; {currentYear} Masala Chai Tea. {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-6">
              <a
                href="#privacy"
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                Privacy Policy
              </a>
              <a
                href="#terms"
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
